import { useEffect, useState } from 'react';
import { RiFacebookLine, RiInstagramLine, RiYoutubeLine } from 'react-icons/ri'
import { SOCIAL_LINKS_API } from '../../../../../Utilities/APIs';

import './SocialLinks.css';

function SocialLinks() {

  const [fbLink, setFbLink] = useState(null);
  const [fbVisibility, setFbVisibility] = useState(null);
  const [instaLink, setInstaLink] = useState(null);
  const [instaVisibility, setInstaVisibility] = useState(null);
  const [youtubeLink, setYoutubeLink] = useState(null);
  const [youtubeVisibility, setYoutubeVisibility] = useState(null);

  async function fetchData() {
		const res = await fetch(SOCIAL_LINKS_API);
		const data = await res.json();

    const fbObj = data?.find(item => item?.name === 'facebook')
    setFbVisibility(fbObj?.visibility)
    setFbLink(fbObj?.link)

    const instaObj = data?.find(item => item?.name === 'instagram')
    setInstaVisibility(instaObj?.visibility)
    setInstaLink(instaObj?.link)

    const youtubeObj = data?.find(item => item?.name === 'youtube')
    setYoutubeVisibility(youtubeObj?.visibility)
    setYoutubeLink(youtubeObj?.link)
		
	}  

  useEffect(() => {
    fetchData()
  }, [])
  

 return (
    <div className='social_wrapper'>

      {fbVisibility && 
        <a href={fbLink} rel="noopener noreferrer" target="_blank" className='facebook'>
          <RiFacebookLine />
        </a>
      }

      {instaVisibility && 
        <a href={instaLink} rel="noopener noreferrer" target="_blank" className='instagram'>
          <RiInstagramLine />
        </a>
      }

      {youtubeVisibility && 
        <a href={youtubeLink} rel="noopener noreferrer" target="_blank" className='youtube'>
          <RiYoutubeLine />
        </a>
      }

    </div>
  )
}

export default SocialLinks